export enum PwdStrengthConditionType {
  minLength = 'minLength',
  upperCase = 'upperCase',
  lowerCase = 'lowerCase',
  number = 'number',
  special = 'special',
}

export enum UserPurposeType {
  CustomerAnalysis = 'CustomerAnalysis',
  SalesAnalysis = 'SalesAnalysis',
  CompetitorAnalysis = 'CompetitorAnalysis',
  FranchiseAnalysis = 'FranchiseAnalysis',
  Other = 'Other',
}

export enum UserAgeGroupType {
  Age20 = 'Age20',
  Age30 = 'Age30',
  Age40 = 'Age40',
  Age50 = 'Age50',
  Age60Over = 'Age60Over',
}

export enum UserCategoryType {
  AuctionInvestor = 'AuctionInvestor',
  FranchiseHeadOffice = 'FranchiseHeadOffice',
  MultiStoreOwner = 'MultiStoreOwner',
  StartupCandidate = 'StartupCandidate',
  Other = 'Other',
}

export enum UserGenderType {
  Female = 'Female',
  Male = 'Male',
  None = 'None',
}

export enum UserProfileType {
  gender = 'gender',
  ageGroup = 'ageGroup',
  category = 'category',
  otherCategory = 'otherCategory',
  purpose = 'purpose',
  other = 'other', // 기타 목적
}

/**
 * 이용 제한 판정 (myAccessRestriction 응답)
 * Account: 로그인한 계정의 이메일·연락처가 제한 중 / Ip: 지금 접속한 IP가 제한 중
 * 둘 다 걸리면 Account 가 내려온다.
 */
export enum AccessRestrictionType {
  Account = 'Account',
  Ip = 'Ip',
}
